import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { savePlanState } from '@store/actions/planAction';
import SatCheckBox from '@components/common/satUI/SatCheckBox';
import { checkProduct } from '@common/utils';

const medicalRecipientOptions = [
  {
    label: '피보험자',
    key: 'insrdMdlcBnfcrYn',
  },
  {
    label: '배우자',
    key: 'spouseMdlcBnfcrYn',
  },
];

const MedicalRecipient = () => {
  const dispatch = useDispatch();

  const { planMainInfo } = useSelector(state => state.planReducer);
  const mainProduct = planMainInfo.planEstablishProduct.find(
    item => item.mainPolicyRiderTypeCode === 'P',
  );
  const isMedicalRecipient = checkProduct(mainProduct, '의료수급권자');

  const handleChange = (key, isChecked) => {
    dispatch(
      savePlanState({
        planMainInfo: {
          [key]: isChecked ? 'Y' : 'N',
        },
      }),
    );
  };

  return (
    <>
      {isMedicalRecipient && (
        <>
          <div className="tit-area">
            <h2>의료수급권자 여부</h2>
          </div>

          <div className="check-box">
            {medicalRecipientOptions.map(({ label, key }) => (
              <SatCheckBox
                key={key}
                value={[planMainInfo[key] === 'Y']}
                options={[{ key, label, value: true }]}
                onChange={isChecked => handleChange(key, isChecked)}
              />
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default MedicalRecipient;
